import * as React from "react";
import { SVGProps } from "react";
const SvgGetInTouch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 7a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-4v4.5a1.25 1.25 0 0 1-2 1L12.667 25H6a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h20Zm0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6.667a2 2 0 0 1 1.2.4L20 28v-3.8a1.2 1.2 0 0 1 1.2-1.2H26a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1Zm-15 5.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5.003 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGetInTouch;
